import {
  IonCard,
  IonCol,
  IonGrid,
  IonIcon,
  IonLabel,
  IonRow,
} from "@ionic/react";
import {
  addCircle,
  colorPalette,
  removeCircle,
  trashOutline,
} from "ionicons/icons";
import { useCart } from "./useCart";
import { NumberMoney } from "../../components/NumberMoney/NumberMoney";
import SubHeader from "../FrameAndEasel/SubHeader";
import { usePictures } from "../Pictures/usePictures";

const ColorPack = () => {
  const { colorPack, changeColorPackNumber } = useCart(); // TODO

  const { equipmentPrice, equipmentState } = usePictures();
  const disabled = !equipmentState.colorPack;
  const allowRemove = colorPack > 0;

  return (
    <IonCard style={{ margin: "3px", padding: "13px 16px 0 16px" }}>
      <SubHeader
        icon={colorPalette}
        text="Set boja (dodatni)"
        onTop
        disabled={disabled}
      >
        <NumberMoney value={equipmentPrice.colorPack} />
      </SubHeader>
      <IonLabel className="center">
        Upisati u napomenu, pre potvrde korpe, za koju šifru motiva želite set
        boja
      </IonLabel>

      {!disabled && (
        <IonGrid>
          <IonRow>
            <IonCol className="ion-text-right">
              {colorPack > 0 && (
                <IonIcon
                  className={allowRemove ? "cursorP" : "op5"}
                  icon={colorPack === 1 ? trashOutline : removeCircle}
                  size="large"
                  color={allowRemove ? "primary" : "var(--ion-color-light)"}
                  onClick={() => {
                    if (allowRemove) {
                      changeColorPackNumber(colorPack - 1);
                    }
                  }}
                />
              )}
            </IonCol>
            <IonCol className="ion-text-center f20 b" style={{ paddingTop: 7 }}>
              <IonLabel>{colorPack}</IonLabel>
            </IonCol>
            <IonCol className="ion-text-left">
              <IonIcon
                className="cursorP"
                color="primary"
                icon={addCircle}
                size="large"
                onClick={() => changeColorPackNumber(colorPack + 1)}
              />
            </IonCol>
          </IonRow>
        </IonGrid>
      )}
      {disabled && (
        <div className="b f15 ion-text-center" style={{ marginBottom: 12 }}>
          <IonLabel>Trenutno nema na stanju</IonLabel>
        </div>
      )}
    </IonCard>
  );
};

export default ColorPack;
